import { useTranslation } from "react-i18next";
import { DateField, InputField, SelectField } from "../Components";
import { colors, fonts, useMediaQuery } from "../Styles";
import { FieldStyles, FieldTypes } from "./";
import { Value } from "baseui/select";
import { useState } from "react";

export enum FilterDisplayEnum {
  // eslint-disable-next-line no-unused-vars
  select = "select",
  // eslint-disable-next-line no-unused-vars
  input = "input",
  // eslint-disable-next-line no-unused-vars
  range = "range",
  // eslint-disable-next-line no-unused-vars
  text = "text",
  // eslint-disable-next-line no-unused-vars
  date = "date",
  // eslint-disable-next-line no-unused-vars
  costum = "costum"
}

export interface field {
  id?: number,
  value?: number
}

export interface FilterDisplayType {
  id: number,
  label: string,
  displayType?: FilterDisplayEnum,
  options?: {
    label: string,
    id: number,
  }[],
  text?: string
}

export const FilterContent = (props: {filter: field, index?: number, filterParameterTypes?: FilterDisplayType[], handleFilterValueChange: (index?: number, value?: Value) => void, costumContent?: JSX.Element }) => { 
  const {t} = useTranslation()
  const [thisDate, setThisDate] = useState<Date>(new Date());
  const {filter, index, filterParameterTypes, handleFilterValueChange, costumContent } = props;
  const filterParameter = filterParameterTypes?.find((filterParameterType) => filterParameterType.id === filter.id)
  const mobileXs = useMediaQuery(`(max-width: 690px)`);

  // Style wrapper for content
  const wrapperStyle = {
    width: "100%",
    height: "fit-content",
    backgroundColor: colors.greyLightSecondary,
    padding: mobileXs? "10px 5px" : "10px",
    borderRadius: "10px"
  };
  
  if (!filterParameter?.displayType) {
    return null
  }
  switch (filterParameter.displayType) {
    case FilterDisplayEnum.select:
      return <div style={{...wrapperStyle, boxSizing: "border-box"}}>
        <SelectField placeholder={t("select")+"..."} onChange={(e:Value) => handleFilterValueChange(index, e)} defaultValue={filterParameter.options?.find((option) => option.id === filter.value)?.label} overrides={{fieldStyle: FieldStyles.greyTertiary, fieldType: FieldTypes.primaryInputField, textStart: true}} options={filterParameter.options}/>
      </div>;
    case FilterDisplayEnum.input:
      return <div style={{...wrapperStyle, boxSizing: "border-box"}}>
        <InputField placeholder={"0..."} inputType="number" fieldStyle={FieldStyles.greyTertiary} fieldType={FieldTypes.shortInputField} textStart={true}/>
        </div>;
    case FilterDisplayEnum.range:
      return <div style={{...wrapperStyle, boxSizing: "border-box"}}>
        <div style={{display: "flex", flexDirection: mobileXs? "column" : "row", alignItems: "center", justifyContent: "start", gap: "10px"}}>
          <div>
            <p style={{ ...fonts.header, ...fonts.fontSize4, color: colors.greyPrimary, padding: "0px 0px 2px 22px" }}>{t("from")}</p>
            <InputField placeholder={"0..."} inputType="number" fieldStyle={FieldStyles.greyTertiary} fieldType={ mobileXs ? FieldTypes.primaryInputField : FieldTypes.shortInputField} textStart={true}/>
          </div>
          <div>
            <p style={{ ...fonts.header, ...fonts.fontSize4, color: colors.greyPrimary, padding: "0px 0px 2px 22px" }}>{t("to")}</p>
            <InputField placeholder={"9999..."} inputType="number" fieldStyle={FieldStyles.greyTertiary} fieldType={ mobileXs ? FieldTypes.primaryInputField : FieldTypes.shortInputField} textStart={true}/>
          </div>
        </div>
      </div>;
    case FilterDisplayEnum.text: // Location
      return <div style={{...wrapperStyle, boxSizing: "border-box"}}>
        <div>
          <p style={{ ...fonts.paragraph, ...fonts.fontSize4, color: colors.greyPrimary}}>
            {filterParameter.text || ""}
          </p>
        </div>
      </div>
    case FilterDisplayEnum.date: // Location
      return <div style={{...wrapperStyle, boxSizing: "border-box"}}>
        <DateField value={thisDate} onChange={({ date }) => setThisDate(date)} fieldStyle={FieldStyles.greyTertiary} textStart={true}/>
      </div>
    case FilterDisplayEnum.costum: // Location
      return <div style={{...wrapperStyle, boxSizing: "border-box"}}>
        {costumContent || <div>No custom content available</div>}
      </div>
    default:
    return null;
  }
};